import script from "./PlatformChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformChip.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformChip.vue?vue&type=style&index=0&id=62fd2b5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fd2b5c"]])

export default __exports__